
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Skill from "../models/Skill";
import Discipline from "../models/Discipline";

@Component
export default class SkillsComponent extends Vue {
  public category = "programming";
  public skills: Skill[] = [];
  public disciplines: Discipline[] = [];

  @Watch("category")
  public changeCategory(category: string) {
    this.category = category;
  }

  public toggleDiscipline(index: number) {
    const disciplineToChange = this.disciplines[index];

    this.disciplines.forEach(element => {
      if (index !== element.id) {
        element.isActive = false;
      }
    });

    disciplineToChange.isActive = !disciplineToChange.isActive;
  }

  public created() {
    this.skills = [
      new Skill(1, "HTML5", "programming", "skill__level skill__level--html5"),
      new Skill(2, "CSS3", "programming", "skill__level skill__level--css3"),
      new Skill(3, "JavaScript", "programming", "skill__level skill__level--javascript"),
      new Skill(40, "jQuery", "programming", "skill__level skill__level--jquery"),
      new Skill(4, "VueJS", "programming", "skill__level skill__level--vuejs"),
      new Skill(
        5,
        "Angular 2",
        "programming",
        "skill__level skill__level--angular2"
      ),
      new Skill(6, "C#", "programming", "skill__level skill__level--csharp"),
      new Skill(
        7,
        "SQL Server",
        "programming",
        "skill__level skill__level--sqlserver"
      ),
      new Skill(
        8,
        "ASP NET",
        "programming",
        "skill__level skill__level--aspnet"
      ),
      new Skill(
        9,
        "NET Core",
        "programming",
        "skill__level skill__level--dotnet"
      ),
      new Skill(
        10,
        "Umbraco CMS",
        "programming",
        "skill__level skill__level--umbraco"
      ),
      new Skill(
        11,
        "Microsoft Bot Framework",
        "programming",
        "skill__level skill__level--botframework"
      ),
      new Skill(
        12,
        "Microsoft Office",
        "programming",
        "skill__level skill__level--office"
      ),
      new Skill(
        13,
        "Jira Atlassian",
        "programming",
        "skill__level skill__level--jira"
      ),
      new Skill(14, "Java", "programming", "skill__level skill__level--java"),
      new Skill(15, "C", "programming", "skill__level skill__level--c"),
      new Skill(16, "Visual Studio", "ide", "skill__level skill__level--vs"),
      new Skill(
        17,
        "Visual Studio Code",
        "ide",
        "skill__level skill__level--vscode"
      ),
      new Skill(18, "Eclipse", "ide", "skill__level skill__level--eclipse"),
      new Skill(
        19,
        "Adobe Photoshop",
        "design",
        "skill__level skill__level--photoshop"
      ),
      new Skill(
        20,
        "Adobe After Effects",
        "design",
        "skill__level skill__level--aftereffects"
      ),
      new Skill(
        21,
        "Adobe Lightroom",
        "design",
        "skill__level skill__level--lightroom"
      ),
      new Skill(22, "VSTS", "programming", "skill__level skill__level--vsts"),
      new Skill(23, "Git", "programming", "skill__level skill__level--git"),
      new Skill(
        24,
        "Spanish",
        "languages",
        "skill__level skill__level--spanish"
      ),
      new Skill(
        25,
        "English",
        "languages",
        "skill__level skill__level--english"
      ),
      new Skill(
        26,
        "Portuguese",
        "languages",
        "skill__level skill__level--portuguese"
      ),
      new Skill(
        27,
        "Italian",
        "languages",
        "skill__level skill__level--italian"
      ),
      new Skill(
        28,
        "Responsable",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        29,
        "Ganas De Crecer",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        30,
        "Atención Al Detalle",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        31,
        "Buena Presencia, Alegre",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        32,
        "Etica Positiva",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        33,
        "Trabajo En Equipo",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        34,
        "Capacidad De Trabajo Bajo Presión",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        35,
        "Innovación",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        36,
        "Flexibilidad",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        37,
        "Capacidad De Organización",
        "personal",
        "skill__level skill__level--personal"
      ),
      new Skill(
        38,
        "Forensics Tool Kit",
        "forensics",
        "skill__level skill__level--ftk"
      ),
      new Skill(
        39,
        "WireShark",
        "forensics",
        "skill__level skill__level--wireshark"
      ),
      new Skill(
        41, 
        "DaVinci Resolve", 
        "design", 
        "skill__level skill__level--davinci")
    ];

    this.disciplines = [
      new Discipline(0, "programming", false),
      new Discipline(1, "ide", false),
      new Discipline(2, "design", false),
      new Discipline(3, "forensics", false),
      new Discipline(4, "languages", false),
      new Discipline(5, "personal", false)
    ];
  }
}
